// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { notification } from "antd";
import { http } from "../../../engine/api/http";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import routes from "../../../engine/routes";
import { useNavigate } from "react-router-dom";

const initialState = {
  users: [],
  principal: {
    _id: undefined,
    institutions: [],
    name: "",
    secondName: "",
    type: "",
    archived: false,
  },
  loading: false,
};

export const getPrincipal = createAsyncThunk(
  "principal/getPrincipal",
  async (principalId, thunkAPI) => {
    const res = await http.get("/principals/" + principalId);
    return res.data;
  },
);

export const getPrincipalUsers = createAsyncThunk(
  "principal/getPrincipalUsers",
  async (principalId, thunkAPI) => {
    const res = await http.get("/principals/" + principalId + "/users");
    return res.data;
  },
);

export const updatePrincipal = createAsyncThunk(
  "principal/update",
  async (payload, thunkAPI, state) => {
    const principal = thunkAPI.getState().principal.principal;

    if (principal._id !== undefined) {
      const res = await http.patch("/principals/" + principal._id, principal);
      notification.success({
        message: `Mandant Modifiée`,
      });
      return res.data;
    } else {
      const res = await http.post("/principals/new", principal);
      // thunkAPI.dispatch(updatePrincipalOnList(res.data));
      notification.success({
        message: `Mandant Créée`,
      });
      return res.data;
    }
  },
);

const principalSlice = createSlice({
  name: "principal",
  initialState,
  reducers: {
    clearPrincipal: state => {
      return initialState;
    },
    setPropertiesPrincipal: (state, action) => {
      state.principal = { ...state.principal, ...action.payload };
    },
  },
  extraReducers: {
    [getPrincipal.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getPrincipal.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.principal = payload;
    },
    [updatePrincipal.pending]: (state, { payload }) => {},
    [updatePrincipal.fulfilled]: (state, { payload }) => {
      state.principal = payload;
    },
    [getPrincipal.rejected]: state => {
      state.loading = false;
    },
    [getPrincipalUsers.pending]: state => {
      state.loading = true;
    },
    [getPrincipalUsers.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.users = payload;
    },
  },
});

export const initPrincipalSlice = ({ id }) => {
  const dispatch = useDispatch();

  const { principal } = useSelector(state => state.principal);
  const navigate = useNavigate();

  const init = () => {
    // if (principal._id !== id && id !== "new") {
    if ( id !== "new") {
      dispatch(getPrincipal(id));
    }
  };

  const clear = () => {
    dispatch(clearPrincipal());
  };

  useEffect(() => {
    if (principal._id !== undefined && id === "new") {
      navigate(routes.principals(principal._id).detail.path, {
        replace: true,
      });
    }
  }, [principal]);

  useEffect(() => {
    init();
    if (id === "new" && principal._id !== undefined) {
      // Reset when go to a new one
      clear();
      navigate(routes.principals().new.path, {
        replace: true,
      });
    }

    return () => {
      // clear();
    };
  }, []);

  return { init, clear };
};

export const {
  clearPrincipal,
  setPropertiesPrincipal,
} = principalSlice.actions;

export const principalReducer = principalSlice.reducer;
